export default "__VITE_ASSET__Dp16FcQW__"